import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import _ from 'lodash';
import {
  /** Wrapper */
  Wrapper,
  MarkdownWrapper,
  ImageWrapper,
  TextWrapper,
  /** Common */
  CommonContainer,
  /** Overlay */
  BlackOverlay,
  Content,
  /** Header */
  Header,
  /** Body */
  Body,
  BodyDescriptionText,
  BodyHeading,
  /** Button */
  Button,
  CloseButton,
  CloseIcon,
  /** Markdown */
  // TODO: スカルプカメラ連携は Phase 2 対象外。以下のスタイルは、後で必要があれば復活させる。
  // MarkdownComponentStyle,
  MarkdownCommon,
  MarkdownSalonSolution,
  /** Other elements */
  // TODO: スカルプカメラ連携は Phase 2 対象外。以下のスタイルは、後で必要があれば復活させる。
  // Image,
  // TODO: スカルプカメラ連携は Phase 2 対象外。以下のスタイルは、後で必要があれば復活させる。
  // Hr,
  Date,
  Spinner,
  Text,
} from './Modal.style';
import FullImage from '../ContentfulImage';
import Placeholder from '../Placeholder';
import Markdown from '../Markdown';
import { generateKey, createLineBreak } from '../../utils';
import { TABLET_P } from '../../constants';

/**
 * 共通コンポーネント - 表示部品トレードバージョン
 *   以下、次の用途で使用する
 *     モーダルボディが、単純な構造の場合
 *
 *   使用箇所
 *     Stylist Tool
 *       1. カスタマーレジスター (新規お客様登録画面の同意書)
 *       2. サインアップ (利用規約)
 *       3. スタイリスト診断 (診断結果保存確認)
 *       4. サロンビジット (編集中内容の破棄確認)
 *       5. サロンソリューション (各商品使用説明)
 *       6. SHISEIDO PROFESSIONAL PARTNERS (New Visit 保存/キャンセル確認)
 * TODO: 以下のコメントは、スカルプカメラ連携が復活したら上記 1 〜 6 と差し替えること。
 // *       1. スカルプカメラアプリ・インストールマニュアル
 // *       2. カスタマーレジスター (新規お客様登録画面の同意書)
 // *       3. サインアップ (利用規約)
 // *       4. スタイリスト診断 (診断結果保存確認)
 // *       5. サロンビジット (編集中内容の破棄確認)
 // *       6. サロンビジット (スカルプカメラ / デバイスカメラ起動)
 // *       7. サロンビジット (スカルプカメラ起動後リロード)
 // *       8. サロンソリューション (各商品使用説明)
 // *       9. SHISEIDO PROFESSIONAL PARTNERS (New Visit 保存/キャンセル確認)
 */
const RecieverFragments = ({
  isOpen,
  hasHeader,
  onClose,
  onClick,
  hasHeading,
  hasBodyDescription,
  contentHeading,
  contentBodyDescription,
  contentBodyItems,
  styleType,
}) => (
  <Modal
    appElement={document.getElementById('root')}
    isOpen={isOpen}
    style={{
      overlay: {
        zIndex: '1999',
        background: styleType === 'partnersNewVisitType' ? 'none' : 'rgba(255, 255, 255, 0.8)',
      },
      content: {
        background: 'none',
        border: 'none',
        top: '0',
        right: '0',
        bottom: '0',
        left: '0',
      },
    }}
  >
    <Wrapper>
      {styleType === 'partnersNewVisitType' && <BlackOverlay />}
      <Content className={styleType || 'commonType'}>
        {hasHeader && (
          <Header onClick={() => onClose()}>
            <CloseButton className={['closeButton', styleType].join(' ')} />
          </Header>
        )}
        <Body className={styleType || 'commonType'}>
          {hasHeading && (
            <React.Fragment>
              {!contentHeading ? <Placeholder w="100%" h="24px" /> : <BodyHeading>{contentHeading}</BodyHeading>}
            </React.Fragment>
          )}
          {hasBodyDescription && (
            <React.Fragment>
              {!contentBodyDescription ? (
                <Placeholder w="100%" h="24px" />
              ) : (
                <BodyDescriptionText>{contentBodyDescription}</BodyDescriptionText>
              )}
            </React.Fragment>
          )}
          {!contentBodyItems ? (
            <Placeholder w="100%" h="24px" />
          ) : (
            <React.Fragment>
              {contentBodyItems.length > 0 &&
                contentBodyItems.map(({ type, item }) => (
                  <CommonContainer key={type} className={styleType || ''}>
                    {/* TODO: カメラ連携は Phase 2 対象外。以下の処理は、後で必要があれば復活させる。 */}
                    {/* スカルプカメラアプリ・インストールマニュアル */}
                    {/*
                    {type === 'IMAGE_MARKDOWN' &&
                      item &&
                      Array.isArray(item) &&
                      item.map(({ image, content }) => (
                        <CommonContainer key={`image-markdown-${image.title}`}>
                          <MarkdownWrapper className={styleType}>
                            <ImageWrapper className={styleType}>
                              <Image className={styleType} src={image.file.url} alt={image.title} />
                            </ImageWrapper>
                            <TextWrapper className={styleType}>
                              <Markdown Component={MarkdownComponentStyle} src={content} />
                            </TextWrapper>
                          </MarkdownWrapper>
                          <Hr />
                        </CommonContainer>
                      ))}
                    */}
                    {/* TODO: カメラ連携は Phase 2 対象外。以下の処理は、後で必要があれば復活させる。 */}
                    {/* スカルプカメラアプリ・インストールマニュアル */}
                    {/*
                    {type === 'NOTE_TITLE' && (
                      <React.Fragment>
                        {!item ? (
                          <Placeholder w="100%" h="24px" />
                        ) : (
                          <Text className={`${styleType}-NoteTitle`}>{item}</Text>
                        )}
                      </React.Fragment>
                    )}
                    */}
                    {/* TODO: カメラ連携は Phase 2 対象外。以下の処理は、後で必要があれば復活させる。 */}
                    {/* スカルプカメラアプリ・インストールマニュアル */}
                    {/*
                    {type === 'NOTE_CONTENT' && (
                      <React.Fragment>
                        {!item ? (
                          <Placeholder w="100%" h="24px" />
                        ) : (
                          <Text className={`${styleType}-NoteContent`}>
                            <Markdown Component={MarkdownCommon} src={item} />
                          </Text>
                        )}
                      </React.Fragment>
                    )}
                    */}
                    {/* カスタマーレジスター (新規お客様登録画面の同意書)、サインアップ (利用規約) */}
                    {type === 'MARKDOWN_DATE' && (
                      <React.Fragment>
                        {!item ? (
                          <Placeholder w="100%" h="24px" />
                        ) : (
                          <React.Fragment>
                            <Text className={styleType}>
                              <Markdown Component={MarkdownCommon} src={item.description} />
                            </Text>
                            <Date>{`${item.copy.date}: ${item.date}`}</Date>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    )}
                    {/* スタイリスト診断 (診断結果保存確認) */}
                    {type === 'BUTTON_BUTTON' && (
                      <React.Fragment>
                        {!item ? (
                          <Placeholder w="100%" h="24px" />
                        ) : (
                          <React.Fragment>
                            <Button
                              className={styleType}
                              onClick={item.saveAndFinish}
                              disabled={item.loadingFinish}
                              loading={item.loadingFinish}
                            >
                              {item.loadingFinish ? (
                                <Spinner />
                              ) : (
                                _.get(item.copy, 'newCustomerRegistModal.saveDiagnosisResultAndExitCtaLabel')
                              )}
                            </Button>
                            <Button
                              className={styleType}
                              onClick={item.saveAndTreatment}
                              disabled={item.loadingTreatment}
                              loading={item.loadingTreatment}
                            >
                              {item.loadingTreatment ? (
                                <Spinner />
                              ) : (
                                _.get(item.copy, 'newCustomerRegistModal.saveDiagnosisResultAndTreatmentCtaLabel')
                              )}
                            </Button>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    )}
                    {/* サロンビジット (編集中内容の破棄確認) */}
                    {type === 'TEXT_BUTTON' && (
                      <React.Fragment>
                        {!item ? (
                          <Placeholder w="100%" h="24px" />
                        ) : (
                          <React.Fragment>
                            <Text className={styleType}>{createLineBreak(_.get(item.siteCopy, 'closeMessage'))}</Text>
                            <React.Fragment>
                              <Button onClick={() => onClick()} className={styleType}>
                                {_.get(item.siteCopy, 'closeBtn')}
                              </Button>
                            </React.Fragment>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    )}
                    {/* TODO: カメラ連携は Phase 2 対象外。以下の処理は、後で必要があれば復活させる。 */}
                    {/* サロンビジット (スカルプカメラ / デバイスカメラ起動) */}
                    {/*
                    {type === 'BUTTON_TEXT' && (
                      <React.Fragment>
                        {!item ? (
                          <Placeholder w="100%" h="24px" />
                        ) : (
                          <React.Fragment>
                            <Button
                              className={`${styleType}-ScalpCamera`}
                              onClick={() => {
                                item.openScalpCamera();
                                onClick();
                              }}
                            >
                              {_.get(item.siteCopy, 'scalpCamera')}
                            </Button>
                            <Text className={styleType}>{_.get(item.siteCopy, 'scalpCameraDesc')}</Text>
                            <Button
                              className={`${styleType}-DeviceCamera`}
                              onClick={() => {
                                item.openDeviceCamera();
                                onClick();
                              }}
                            >
                              {_.get(item.siteCopy, 'deviceCamera')}
                            </Button>
                            <Text className={styleType}>{_.get(item.siteCopy, 'deviceCameraDesc')}</Text>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    )}
                    */}
                    {/* TODO: カメラ連携は Phase 2 対象外。以下の処理は、後で必要があれば復活させる。 */}
                    {/* サロンビジット (スカルプカメラ起動後リロード) */}
                    {/*
                    {type === 'RELOAD' && (
                      <React.Fragment>
                        {!item ? (
                          <Placeholder w="100%" h="24px" />
                        ) : (
                          <React.Fragment>
                            <Button className={styleType} onClick={item.reloadAfterOpenScalpCamera}>
                              RELOAD
                            </Button>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    )}
                    */}
                    {/* サロンソリューション (各商品使用説明) */}
                    {type === 'IMAGE_CONTENT' && (
                      <React.Fragment>
                        <MarkdownWrapper className={styleType}>
                          <ImageWrapper className={styleType}>
                            <FullImage
                              src={item.src}
                              options={{
                                w: '100%',
                                h: window.innerWidth > TABLET_P ? '100%' : '360px',
                                objectFit: 'contain',
                              }}
                            />
                          </ImageWrapper>
                          <TextWrapper className={styleType}>
                            <Text className={`${styleType}-ProductName`}>{_.get(item.product, 'product.name')}</Text>
                            {_.get(item.product, 'product.description') && (
                              <Text className={`${styleType}-Description`}>{item.product.product.description}</Text>
                            )}
                            {_.get(item.product, 'usage') && (
                              <React.Fragment>
                                <Text className={`${styleType}-Method`}>{_.get(item.copy, 'method')}</Text>
                                <Markdown Component={MarkdownSalonSolution} src={_.get(item.product, 'usage')} />
                              </React.Fragment>
                            )}
                            {_.get(item.product, 'amountOfUse') && (
                              <React.Fragment>
                                <Text className={`${styleType}-AmountOfUseTitle`}>{_.get(item.copy, 'usage')}</Text>
                                <Text className={`${styleType}-AmountOfUseList`}>
                                  {_.get(item.product, 'amountOfUse').map((amountOfUse, index) => (
                                    <li key={generateKey(amountOfUse, index)}>{amountOfUse}</li>
                                  ))}
                                </Text>
                              </React.Fragment>
                            )}
                          </TextWrapper>
                        </MarkdownWrapper>
                      </React.Fragment>
                    )}
                    {/* SHISEIDO PROFESSIONAL PARTNERS (New Visit 保存確認) */}
                    {type === 'TEXT_BUTTON_BUTTON' && (
                      <React.Fragment>
                        {!item && <Placeholder w="100%" h="24px" />}
                        {item && (
                          <CloseButton className={styleType} onClick={() => onClose()}>
                            <CloseIcon />
                          </CloseButton>
                        )}
                        {item &&
                          _.get(item, 'saveModal') && (
                            <React.Fragment>
                              <Text className={styleType}>{_.get(item.copy, 'modal_confirmation')}</Text>
                              <Button className={`${styleType}-Save`} onClick={item.handleSaveDetails}>
                                {_.get(item.copy, 'proceed_to_save')}
                              </Button>
                              <Button className={`${styleType}-Cancel`} onClick={() => onClose()}>
                                {_.get(item.copy, 'cancel')}
                              </Button>
                            </React.Fragment>
                          )}
                        {item &&
                          !_.get(item, 'saveModal') && (
                            <React.Fragment>
                              <Text className={styleType}>{_.get(item.copy, 'cancel_modal_confirmation')}</Text>
                              <Button className={`${styleType}-Save`} onClick={item.handleExit}>
                                {_.get(item.copy, 'proceed_to_exit')}
                              </Button>
                              <Button className={`${styleType}-Cancel`} onClick={() => onClose()}>
                                {_.get(item.copy, 'cancel')}
                              </Button>
                            </React.Fragment>
                          )}
                      </React.Fragment>
                    )}
                  </CommonContainer>
                ))}
            </React.Fragment>
          )}
        </Body>
      </Content>
    </Wrapper>
  </Modal>
);

RecieverFragments.defaultProps = {
  onClose: null,
  onClick: null,
  contentHeading: null,
  contentBodyDescription: null,
  hasHeading: null,
  hasBodyDescription: null,
  styleType: null,
};

RecieverFragments.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  hasHeader: PropTypes.bool.isRequired,
  contentBodyItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  hasHeading: PropTypes.bool,
  hasBodyDescription: PropTypes.bool,
  contentHeading: PropTypes.string,
  contentBodyDescription: PropTypes.string,
  styleType: PropTypes.string,
};

export default RecieverFragments;



// WEBPACK FOOTER //
// ./src/components/Modal/RecieverFragments.js